import { createSlice } from "@reduxjs/toolkit";
const initialState =
{
  vRNew: true,
  vRSave: true,
  vRDelete: true,
  vRApprove: true,
  VRPrint: true,
  vRReverse: true,
  vRCancel: false,
  VRClone: true
};
const GrnNavBtnSlice = createSlice({
  name: "grnNavBtn",
  initialState: { value: initialState },

  reducers: {
    SetGrnGrnNavBtnSlice: (state, action) => {
      state.value = action.payload;
    },

    ClearGrnGrnNavBtnSlice: (state) => {
      state.value = initialState;
    },
  },
});

export const { SetGrnGrnNavBtnSlice, ClearGrnGrnNavBtnSlice } = GrnNavBtnSlice.actions;
export default GrnNavBtnSlice.reducer;
